/* eslint-disable */
import React, {memo, useEffect, useState} from 'react';
import cn from 'classnames';
import {daysOfWeek, selectedDaysArray} from '../constants';
import {DashboardDay} from '../../dashboard/styles';
import {useDaysPickerContext} from '../context/DaysPickerContext';
import DaysRow from './DaysRow';

const DaysPickerDays = ({day}) => {
  const [selectedDays, setSelectedDays] = useState(selectedDaysArray());
  const openingDays = useDaysPickerContext();

  useEffect(() => {
    const nextDays = selectedDaysArray();

    openingDays.forEach((day) => {
      day.days.forEach((dayName) => {
        if (Object.prototype.hasOwnProperty.call(nextDays, dayName)) {
          nextDays[dayName] = true;
        }
        // if (nextDays.hasOwnProperty(dayName)) {
        //   nextDays[dayName] = true;
        // }
      });
    });

    setSelectedDays(nextDays);
  }, [openingDays]);

  return (
    <>
      <DaysRow selectedDays={selectedDays} day={day} />
    </>
  );
};

export default memo(DaysPickerDays);
